import { PAGE_ROUTES } from '@common/constants';
import {
  getSessionStorage,
  getLocalStorage,
  isResponseOk,
  setLocalStorage,
  setSessionStorage,
  clearLocalStorage,
} from '@common/helpers/helpers';
import { AUTH_PATHS } from '@common/network/ApiPaths';
import { getByPathAndParams, postByPathAndData } from '@services/newServices';
import { create } from 'zustand';
import { createTheme } from '@mui/material';

const getHeadersWithToken = (token) => {
  return {
    'Content-Type': 'application/json',
    authorization: `Bearer ${token}`,
  };
};

const checkPathForCustomEmail = ({ data, customEmail }) => {
  return customEmail && data?.payload?.customEmail
    ? PAGE_ROUTES.CUSTOM_EMAIL
    : PAGE_ROUTES.TEMPLATES;
};

const createCustomTheme = (customTheme) => {
  if (!customTheme) return;

  try {
    return createTheme(
      require('../common/providers/ThemeProvider/' + customTheme + '.json'),
    );
  } catch (err) {
    console.log('err: ', err);
    return;
  }
};

const userStorage =
  getSessionStorage('auth') || getLocalStorage('auth') || null;

export const useAuthStore = create((set) => ({
  isAuthenticated: !!userStorage?.token,
  token: userStorage?.token,
  userName: userStorage?.user?.username || userStorage?.username || '',
  userTheme: createCustomTheme(userStorage?.theme),
  colorMode: getLocalStorage('colorMode') || 'light',
  setColorMode: (newColor) => {
    setLocalStorage('colorMode', newColor);
    set({ colorMode: newColor });
  },
  setSession: (token, user) => set({ status: 'authenticated', token, user }),
  login: async ({ username, password }) => {
    const response = await postByPathAndData({
      path: AUTH_PATHS.LOGIN,
      data: {
        username,
        password,
      },
    });

    const userDetailsResponse = response.data;

    const userTheme = createCustomTheme(userDetailsResponse.theme);
    const token = userDetailsResponse?.token;
    const userName = userDetailsResponse?.user?.username || '';
    const colorMode = getLocalStorage('colorMode') || 'light';

    setLocalStorage('auth', userDetailsResponse);

    set({ userTheme, token, userName, colorMode, isAuthenticated: true });

    return PAGE_ROUTES.TEMPLATES;
  },
  checkToken: async ({ token, customEmail }) => {
    const response = await getByPathAndParams({
      path: AUTH_PATHS.CHECK,
      headers: getHeadersWithToken(token),
    });

    if (isResponseOk(response)) {
      const theme = response?.data?.payload?.theme;
      const sessionState = {
        token,
        theme,
        username: response?.data?.payload?.username || 'guest',
        isAuthenticated: true,
      };
      setSessionStorage('auth', sessionState);
      set({ ...sessionState, userTheme: createCustomTheme(theme) });

      const checkPath = checkPathForCustomEmail({
        data: response?.data,
        customEmail,
      });

      return checkPath;
    }
  },
  logout: () => {
    clearLocalStorage('store');
    set({ isAuthenticated: null, token: null, userName: '' });
  },
}));
